import { BIG_QUERY } from '../../eventName';
import registerBigQueryListener from '../../../tools/bigQuery/listener/browser';

/**
 * Listen to global event bus on BIG_QUERY events
 * @param  {String} options.host url to post events
 * @param  {String} [options.facility] helper added on each event
 * @param  {String} [options.mode] 'development' or not
 */
const bigQueryListener = (options) => registerBigQueryListener({ ...options, busEventName: BIG_QUERY });

export default bigQueryListener;
